import Axios from 'axios'
import router from '@/router'
import { vueAppApiBaseAddress } from '@/utils/mixins'

var initialState = {}

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async logEvent({ commit }, request) {
    return await Axios.post(vueAppApiBaseAddress() + `v2/Event/log`, request, {
      withCredentials: true
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
